/** OWNER membership row. memberOf is a different set and is not read. */
export type OwnedMembership = {
  type?: string | null;
  groupId?: string | null;
};

/** Team ids from OWNER memberships, in list order. No descendant expansion. */
export const ownedTeamIds = (
  memberships: readonly OwnedMembership[] | null | undefined
): string[] => {
  const ids: string[] = [];
  for (const membership of memberships ?? []) {
    const id = membership.groupId;
    if (membership.type !== "OWNER" || !id || ids.includes(id)) {
      continue;
    }
    ids.push(id);
  }
  return ids;
};

/** Same ids, any order. Duplicates are not collapsed. */
export const sameTeamIds = (
  left: readonly string[],
  right: readonly string[]
): boolean => {
  if (left.length !== right.length) {
    return false;
  }
  const a = [...left].sort();
  const b = [...right].sort();
  return a.every((id, index) => id === b[index]);
};

export const inboxTeamFilterLabel = ({
  teamIds,
  teamName,
  ownedTeamIds: owned,
}: {
  teamIds: readonly string[];
  teamName: string | null;
  ownedTeamIds: readonly string[];
}): string | null => {
  if (teamIds.length === 0) {
    return null;
  }
  if (teamIds.length === 1) {
    return teamName ?? teamIds[0] ?? null;
  }
  if (owned.length > 0 && sameTeamIds(teamIds, owned)) {
    return "My teams";
  }
  return "selected teams";
};
